import React from "react"
import { Grid, Link } from "@mui/material";
import DesktopMenu from "./desktopMenudt.js"
import MobileMenu from "./mobileMenudt.js"
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import CasinoOutlinedIcon from '@mui/icons-material/CasinoOutlined';
import ChairAltOutlinedIcon from '@mui/icons-material/ChairAltOutlined';

// import './menu.css'

import logo from '../../images/dashboardlogo.png'

const MenuList = [
    [
        'Dashboard', // title
        '/dashboard', // Link
        'Global---menu-link pb-4 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'dashboard_customize'
    ],
    [
        'Stake',
        '/stake', 
        'Global---menu-link pb-4 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'layers'
    ],
    [
        'Bonds',
        '/together',
        'Global---menu-link pb-4 mx-1', // Class for Desktop
        'Global---menu-link px-3 py-2 mx-3 pr-5', // Class for Mobile
        'view_carousel'
    ]
];
const Menu = () => {
    return(
        <Grid item xs={12} md={2} className="Global-main-menu-outer text-md-center w-100 pb-0 py-md-4 px-0 ">
            <div className="d-none d-md-block">
                <DesktopMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
            <div className="d-md-none">
                <MobileMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
        </Grid>
    )
}

export default Menu;